<template>
  <div>
    <vs-tabs>
      <vs-tab label="List">
        <div class="mt-4">
          <OrderList />
        </div>
      </vs-tab>
      <vs-tab label="Group by Address">
        <div class="mt-4">
          <GroupByAddress />
        </div>
      </vs-tab>
    </vs-tabs>
  </div>
</template>

<script>
import OrderList from './components/OrderList';
import GroupByAddress from "./components/GroupByAddress";

export default {
  components: {
    OrderList,
    GroupByAddress
  }
}
</script>
